import { formatNumber } from '@agro1desenvolvimento/utils-js';
import {
  DefensivoFormValue,
  ItemEstoque,
  ItemSaldo,
  UnidadeConversao,
} from '../../../@types';

type TratamentoIdentificationParams = {
  sementeOrigemId: number;
  sementeDestinoId: number;
  defensivos: DefensivoFormValue[];
};

type PesoEmKgParams = {
  unidade?: UnidadeConversao;
  quantidade?: number;
  pms?: number;
};

type CalculaPesoEmKgParams = {
  taxaSementes?: number;
  pms?: number;
  quantidade?: number;
};

type CalculaTotalParams = {
  quantidade?: number;
  peso?: number;
  dose: number;
};

type SegundoTratamentoParams = {
  sementeOrigem?: ItemSaldo;
  sementeDestino?: ItemEstoque;
};

export const isSegundoTratamento = ({
  sementeOrigem,
  sementeDestino,
}: SegundoTratamentoParams) =>
  Boolean(
    sementeOrigem &&
      sementeDestino &&
      sementeOrigem.id === sementeDestino.itemId,
  );

export const getTratamentoIdentification = ({
  sementeOrigemId,
  sementeDestinoId,
  defensivos,
}: TratamentoIdentificationParams) => {
  const defensivosString = defensivos
    .map((defensivo) => defensivo.item?.descricao)
    .join('-');

  return `${sementeOrigemId}-${sementeDestinoId}-${defensivosString}`;
};

export const calculaPesoComPms = ({
  taxaSementes,
  pms,
  quantidade,
}: CalculaPesoEmKgParams) => {
  if (!taxaSementes || !pms || !quantidade) return 0;

  return ((taxaSementes * pms) / 1000 / 1000) * quantidade;
};

export const getPesoComPms = ({ unidade, quantidade, pms }: PesoEmKgParams) => {
  if (!unidade || !quantidade || unidade.taxa === 0) return undefined;

  if (unidade?.taxaSementes && pms) {
    return calculaPesoComPms({
      taxaSementes: unidade.taxaSementes,
      pms,
      quantidade,
    });
  }

  return quantidade * unidade.taxa;
};

export const humanizePesoComPms = (params: PesoEmKgParams) => {
  const pesoComPms = getPesoComPms(params);

  if (pesoComPms === undefined) return '-';

  return formatNumber(pesoComPms, {
    maximumFractionDigits: 4,
    useGrouping: true,
  });
};

export const calculaQuantidadeInsumo = ({
  quantidade,
  peso,
  dose,
}: CalculaTotalParams) => {
  const formattedQuantidade = quantidade || 0;
  const formattedPeso = peso || 0;

  const totalComPeso = (dose * formattedPeso) / 100;
  const totalComQuantidade = (formattedQuantidade / 100) * dose;

  return formattedPeso > 0 ? totalComPeso : totalComQuantidade;
};
